export let LocalStorageKeySuffix = /*#__PURE__*/function (LocalStorageKeySuffix) {
  LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
  LocalStorageKeySuffix["QUEUE"] = "queue";
  LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
  LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
  LocalStorageKeySuffix["ACK"] = "ack";
  return LocalStorageKeySuffix;
}({});
export let Timers = /*#__PURE__*/function (Timers) {
  Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
  Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
  Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
  return Timers;
}({});